import { create } from 'zustand'

type StatusBarStyle = 'default' | 'light-content' | 'dark-content'

interface IStatusBarColorStore {
    statusBarColor: StatusBarStyle
    setStatusBarColor: (color: StatusBarStyle) => void
}

export const useStatusBarColorStore = create<IStatusBarColorStore>((set) => ({
    statusBarColor: 'dark-content',
    setStatusBarColor: (color: StatusBarStyle) => set({ statusBarColor: color })
}))
